import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Spin} from 'antd'
import ModalTableItem from './ModalTableItem'

class ModalBasketsTable extends Component {
    render() {
        const {items, loading , onDeleteSetBasket, basketNumber} = this.props

        return (
            <div className='BasketsTable'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        <tr>
                            <th>Barcode item</th>
                            <th>SET</th>
                            <th style={{textAlign: 'center'}}>Trạng thái</th>
                            <th></th>
                            <th>Tháo tác</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            items.length > 0 ? 
                            items.map(item => <ModalTableItem key={item._id} item={item} onDeleteSetBasket={onDeleteSetBasket} basketNumber={basketNumber}/>)
                            :
                            <tr className='NoBaskets'>
                                <td colSpan={5}><i>Chưa có item</i></td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

ModalBasketsTable.propTypes = {
    baskets: PropTypes.array.isRequired,
}

export default ModalBasketsTable
